import React from "react";
import SummaryWrapper from "../../../../IpEMR/InspectionSummaries/SummaryWrapper";
import { checkEmpty } from "../../../../../helpers/utility";
import {
  activePassiveOptions,
  cardioChiefComplaintOptions,
  cardioCongenitalOptions,
  cardioHistoryOptions,
  cardioPastMedicalOptions,
  habitOptions,
  opExaminationOptions,
} from "../OpPhysioOptions";
import {
  getLabel,
  getLabelScalesTags,
  getLabelTag,
  getLabelTagInput,
  getLabelTagsArray,
  getLabelTagsWithDescription,
  getLabelTagsWithDynamicInputs,
  getLabelTagYesNO,
  getTherapyLabelTags,
} from "../../../../IpEMR/InspectionSummaries/constructTextFromValues";
import {
  alcoholOptions,
  smokingOptions,
} from "../../../../IpEMR/Options/historyOptions";
import {
  cardioDiagnosisOptions,
  cardioTherapyOptions,
  mmtScaleOptions,
} from "../../../../IpEMR/Options/physioOptions";
import {
  barthelIndexOptions,
  genderOptions,
  minsWalkedOptions,
  reasonOptions,
  rpeOptions,
} from "../../../../IpEMR/Options/functionalAsessmentOptions";
import { genderOptions as peakFlowGenderOptions } from "../../../../IpEMR/Options/systemicExamOptions";
import "../../../../IpEMR/summary.css";
import { getExerciseSummary } from "../../../../IpEMR/InspectionSummaries/constructTextFromValues";

const predictPEFR = (gender, age, height) => {
  if (gender && age && height) {
    switch (gender) {
      case "male adult":
        return Math.round(((height / 100) * 5.48 + 1.58 - age * 0.041) * 60);
      case "female adult":
        return Math.round(((height / 100) * 3.72 + 2.24 - age * 0.03) * 60);
      case "child":
        return Math.round((height - 100) * 5 + 100);
      default:
        return "";
    }
  } else {
    return "";
  }
};
const getHabitLabel = (value) => {
  return habitOptions.find((opt) => opt.value === value)?.label || value || "-";
};

const CardioSummary = ({ formData }) => {
  // if (formData?.history) {
  //   console.log("Smoking:", formData.history.smoking);
  //   console.log("Alcohol:", formData.history.alcohol);
  // }
  const constructCardioSummaryItems = () => {
    const getRomSummary = (list, data) => {
      const enteredOptions = list.reduce((acc, item) => {
        const filtered = Object.entries(data).filter(([key, value]) =>
          key.endsWith(item)
        );
        return [...acc, ...filtered];
      }, []);

      return enteredOptions?.length === 0
        ? null
        : enteredOptions?.map(([key, value]) => (
            <React.Fragment key={key}>
              {getLabelTagInput(
                key
                  .split("_")
                  .map(
                    (word) =>
                      word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                  )
                  .join(" "),
                value
              )}
            </React.Fragment>
          ));
    };
    const cardioSummaryItems = [];
    const pushSummaryItem = (key, label, children) => {
      cardioSummaryItems.push({ key, label, children });
    };
    if (checkEmpty(formData?.chief_complaint)) {
      pushSummaryItem(
        "1",
        "Chief Complaints",
        <>
          {getLabelTagsArray(
            cardioChiefComplaintOptions,
            formData?.chief_complaint?.chief_complaints
          )}
          {getLabelTagInput("Comments", formData?.chief_complaint?.comments)}
        </>
      );
    }

    if (checkEmpty(formData?.history)) {
      const pastMedicalHistoryValues = formData?.history?.past_medical_history;
      const showPastMedicalOthersRemarks =
        Array.isArray(pastMedicalHistoryValues) &&
        pastMedicalHistoryValues.includes("past_medical_others");

      const congenitalDisordersValues = formData?.history?.congenital_disorders;
      const showCongenitalOtherRemarks =
        Array.isArray(congenitalDisordersValues) &&
        congenitalDisordersValues.includes("cardio_congenital_options");

      pushSummaryItem(
        "2",
        "History",
        <>
          {(checkEmpty(formData?.history?.history) ||
            checkEmpty(formData?.history?.history_comments)) &&
            getLabelTagInput(
              "History",
              <>
                {getLabelTagsArray(
                  cardioHistoryOptions,
                  formData?.history?.history
                )}
                {formData?.history?.history_comments &&
                  getLabelTagInput(
                    "Comments",
                    formData?.history?.history_comments
                  )}
              </>
            )}

          {(checkEmpty(pastMedicalHistoryValues) ||
            (showPastMedicalOthersRemarks &&
              checkEmpty(formData?.history?.past_medical_comments))) &&
            getLabelTagInput(
              "Past Medical History",
              <>
                {getLabelTagsArray(
                  cardioPastMedicalOptions,
                  pastMedicalHistoryValues
                )}
                {showPastMedicalOthersRemarks &&
                  formData?.history?.past_medical_comments &&
                  formData.history.past_medical_comments.map((item, idx) => (
                    <React.Fragment key={item?.id ?? item?.remarks ?? idx}>
                      {getLabelTagInput(`Remarks ${idx + 1}`, item.remarks)}
                    </React.Fragment>
                  ))}
              </>
            )}
          {(checkEmpty(congenitalDisordersValues) ||
            checkEmpty(formData?.history?.congenital_disorders_comments) ||
            (showCongenitalOtherRemarks &&
              checkEmpty(formData?.history?.congenital_disorders_other))) &&
            getLabelTagInput(
              "Congenital Disorders",
              <>
                {getLabelTagsArray(
                  cardioCongenitalOptions,
                  congenitalDisordersValues
                )}

                {showCongenitalOtherRemarks &&
                  Array.isArray(
                    formData?.history?.congenital_disorders_other
                  ) &&
                  formData.history.congenital_disorders_other.map(
                    (item, idx) => (
                      <React.Fragment key={item?.id ?? item?.remarks ?? idx}>
                        {getLabelTagInput(`Remarks ${idx + 1}`, item.remarks)}
                      </React.Fragment>
                    )
                  )}

                {formData?.history?.congenital_disorders_comments &&
                  getLabelTagInput(
                    "Comments",
                    formData?.history?.congenital_disorders_comments
                  )}
              </>
            )}

          {formData?.history?.past_surgical_history &&
            getLabelTagInput(
              "Past Surgical History",
              <>
                {formData.history.past_surgical_history === "yes"
                  ? "Yes"
                  : "No"}
                {formData?.history?.past_surgical_comments &&
                  getLabelTagInput(
                    "Comments",
                    formData?.history?.past_surgical_comments
                  )}
              </>
            )}

          {formData?.history?.smoking &&
            getLabelTagInput(
              "Smoking",
              getLabelTag(smokingOptions, formData.history.smoking)
            )}
          {formData?.history?.alcohol &&
            getLabelTagInput(
              "Alcohol",
              getLabelTag(alcoholOptions, formData.history.alcohol)
            )}

          {formData?.history?.life_style &&
            getLabelTagInput(
              "Life Style",
              getLabelTag(habitOptions, formData?.history?.life_style)
            )}
          {formData?.history?.habits_comments &&
            getLabelTagInput("Comments", formData?.history?.habits_comments)}
        </>
      );
    }

    if (checkEmpty(formData?.vitals)) {
      pushSummaryItem(
        "3",
        "Vitals",
        <>
          {getLabelTagInput("Temperature", formData?.vitals?.temperature, "°F")}
          {getLabelTagInput("Pulse Rate", formData?.vitals?.pulse_rate, "bpm")}
          {getLabelTagInput(
            "Respiratory Rate",
            formData?.vitals?.respiratory_rate,
            "breaths/min"
          )}
          {getLabelTagInput(
            "Systolic BP",
            formData?.vitals?.systolic_bp,
            "mmHg"
          )}
          {getLabelTagInput(
            "Diastolic BP",
            formData?.vitals?.diastolic_bp,
            "mmHg"
          )}
          {getLabelTagInput("spO2", formData?.vitals?.spo2, "%")}
        </>
      );
    }

    if (checkEmpty(formData?.examination)) {
      pushSummaryItem(
        "4",
        "Examination",
        <>
          {getLabelTagsWithDescription(
            opExaminationOptions,
            formData?.examination
          )}
          {getLabelTagInput("Pain level", formData?.examination?.pain)}
          {getLabelTagInput(
            "Interpretation",
            formData?.examination?.pain_interpretation
          )}
          {getLabelTagInput(
            "Comments",
            formData?.examination?.examination_comments
          )}
        </>
      );
    }

    if (checkEmpty(formData?.mmt)) {
      pushSummaryItem(
        "5",
        "MMT",
        <>
          {getLabelTagInput(
            "Left Upper Limb",
            getLabelTag(mmtScaleOptions, formData?.mmt?.upper_left_limb)
          )}
          {getLabelTagInput(
            "Right Upper Limb",
            getLabelTag(mmtScaleOptions, formData?.mmt?.upper_right_limb)
          )}
          {getLabelTagInput(
            "Left Lower Limb",
            getLabelTag(mmtScaleOptions, formData?.mmt?.lower_left_limb)
          )}
          {getLabelTagInput(
            "Right Lower Limb",
            getLabelTag(mmtScaleOptions, formData?.mmt?.lower_right_limb)
          )}
          {formData?.mmt?.comments &&
            getLabelTagInput("Comments", formData?.mmt?.comments)}
        </>
      );
    }

    if (checkEmpty(formData?.rom)) {
      pushSummaryItem(
        "6",
        "ROM",
        <>
          {formData?.rom?.shoulder_joint &&
            getLabelTagInput(
              "Shoulder Joint",
              getRomSummary(
                [
                  "flexion",
                  "extension",
                  "abduction",
                  "adduction",
                  "medial_rotation",
                  "lateral_rotation",
                ],
                formData?.rom?.shoulder_joint
              )
            )}
          {formData?.rom?.elbow_joint &&
            getLabelTagInput(
              "Elbow Joint",
              getRomSummary(
                ["flexion", "extension"],
                formData?.rom?.elbow_joint
              )
            )}
          {formData?.rom?.forearm_joint &&
            getLabelTagInput(
              "Forearm Joint",
              getRomSummary(
                ["supination", "pronation"],
                formData?.rom?.forearm_joint
              )
            )}
          {formData?.rom?.wrist_joint &&
            getLabelTagInput(
              "Wrist Joint",
              getRomSummary(
                ["flexion", "extension", "radial_deviation", "ulnar_deviation"],
                formData?.rom?.wrist_joint
              )
            )}
          {formData?.rom?.thumb_joint &&
            getLabelTagInput(
              "Thumb Joint",
              getRomSummary(
                ["cmc_flexion", "cmc_extension", "cmc_abduction", "ip_flexion"],
                formData?.rom?.thumb_joint
              )
            )}
          {formData?.rom?.metacarpel_joint &&
            getLabelTagInput(
              "MetaCarpel Joint",
              getRomSummary(
                ["flexion", "hyperextension", "abduction"],
                formData?.rom?.metacarpel_joint
              )
            )}
          {formData?.rom?.proximal_joint &&
            getLabelTagInput(
              "Proximal Interphalangeal Joint",
              getRomSummary(
                ["flexion", "extension"],
                formData?.rom?.proximal_joint
              )
            )}
          {formData?.rom?.disital_joint &&
            getLabelTagInput(
              "Distal Interphalangeal Joint",
              getRomSummary(
                ["flexion", "extension"],
                formData?.rom?.disital_joint
              )
            )}
          {formData?.rom?.hip_joint &&
            getLabelTagInput(
              "Hip Joint",
              getRomSummary(
                [
                  "flexion",
                  "extension",
                  "abduction",
                  "adduction",
                  "medial_rotation",
                  "lateral_rotation",
                ],
                formData?.rom?.hip_joint
              )
            )}
          {formData?.rom?.knee_joint &&
            getLabelTagInput(
              "Knee Joint",
              getRomSummary(["flexion", "extension"], formData?.rom?.knee_joint)
            )}
          {formData?.rom?.ankle_joint &&
            getLabelTagInput(
              "Ankle Joint",
              getRomSummary(
                ["dorsiflexion", "plantarflexion"],
                formData?.rom?.ankle_joint
              )
            )}
          {formData?.rom?.foot_joint &&
            getLabelTagInput(
              "Foot Joint",
              getRomSummary(
                ["inversion", "eversion"],
                formData?.rom?.foot_joint
              )
            )}
          {formData?.rom?.great_toe_joint &&
            getLabelTagInput(
              "Great Toe Joint",
              getRomSummary(
                ["flexion", "extension"],
                formData?.rom?.great_toe_joint
              )
            )}
          {formData?.rom?.inter_phalangeal_joint &&
            getLabelTagInput(
              "Inter Phalangeal Joint",
              getRomSummary(
                ["flexion", "extension"],
                formData?.rom?.inter_phalangeal_joint
              )
            )}
          {formData?.rom?.cervical_spine &&
            getLabelTagInput(
              "Cervical Spine",
              getRomSummary(
                [
                  "flexion",
                  "extension",
                  "right_rotation",
                  "left_rotation",
                  "right_lateral_rotation",
                  "left_lateral_rotation",
                ],
                formData?.rom?.cervical_spine
              )
            )}
          {formData?.rom?.thoraco_lumbar_spine &&
            getLabelTagInput(
              "Thoraco Lumbar Spine",
              getRomSummary(
                [
                  "flexion",
                  "extension",
                  "right_rotation",
                  "left_rotation",
                  "right_lateral_rotation",
                  "left_lateral_rotation",
                ],
                formData?.rom?.thoraco_lumbar_spine
              )
            )}
        </>
      );
    }

    const barthelData = formData?.barthel_index || formData?.barthel;
    if (checkEmpty(barthelData)) {
      pushSummaryItem(
        "7",
        "Barthel Index",
        <>
          {getLabelTagInput("Score", barthelData?.score)}
          {getLabelTagInput("Interpretation", barthelData?.interpretation)}
          {getLabelScalesTags(barthelIndexOptions, barthelData)}
          {getLabelTagInput("Comments", barthelData?.comments)}
        </>
      );
    }

    if (checkEmpty(formData?.rpe)) {
      pushSummaryItem(
        "8",
        "RPE",
        <>
          {" "}
          {getLabelTagInput("Score", formData?.rpe?.exertion)}
          {getLabelTagInput("Interpretation", formData?.rpe?.interpretation)}
          {getLabelTagInput("Comments", formData?.rpe?.comments)}
        </>
      );
    }

    if (checkEmpty(formData?.six_min_walk)) {
      pushSummaryItem(
        "9",
        "six minutes walk test",
        <>
          {getLabelTag(genderOptions, formData?.six_min_walk?.gender)}
          {getLabelTagInput("Age", formData?.six_min_walk?.age)}
          {getLabelTagInput("Height", formData?.six_min_walk?.height, "cms")}
          {getLabelTagInput("Weight", formData?.six_min_walk?.weight, "kgs")}
          {getLabelTagInput(
            "Predicted Distance",
            formData?.six_min_walk?.predicted_distance
          )}
          {getLabelTagInput(
            "Pre Vitals",
            <>
              {getLabelTagInput(
                "Heart Rate",
                formData?.six_min_walk?.heart_rate,
                "beats/min"
              )}
              {getLabelTagInput("SBP", formData?.six_min_walk?.sbp, "mmHg")}
              {getLabelTagInput("DBP", formData?.six_min_walk?.dbp, "mmHg")}
              {getLabelTagInput("SPO2", formData?.six_min_walk?.spo2, "%")}
              {getLabelTagInput(
                "RR",
                formData?.six_min_walk?.rr,
                "breaths/min"
              )}
              {getLabelTagInput(
                "RPE",
                getLabelTag(rpeOptions, formData?.six_min_walk?.rpe)
              )}
            </>
          )}
          {getLabelTagInput(
            "Post Vitals",
            <>
              {getLabelTagInput(
                "Heart Rate",
                formData?.six_min_walk?.post_vital_heart_rate,
                "beats/min"
              )}
              {getLabelTagInput(
                "SBP",
                formData?.six_min_walk?.post_vital_sbp,
                "mmHg"
              )}
              {getLabelTagInput(
                "DBP",
                formData?.six_min_walk?.post_vital_dbp,
                "mmHg"
              )}
              {getLabelTagInput(
                "SPO2",
                formData?.six_min_walk?.post_vital_spo2,
                "%"
              )}
              {getLabelTagInput(
                "RR",
                formData?.six_min_walk?.post_vital_rr,
                "breaths/min"
              )}
              {getLabelTagInput(
                "RPE",
                getLabelTag(rpeOptions, formData?.six_min_walk?.post_vital_rpe)
              )}
            </>
          )}
          {getLabelTagInput("No Of Laps", formData?.six_min_walk?.no_of_laps)}
          {getLabelTagInput(
            "Distance Walked",
            formData?.six_min_walk?.distance_covered,
            "mtr"
          )}
          {getLabelTagInput(
            "Final Partial Lap",
            formData?.six_min_walk?.final_lap_in_meters,
            "mtr"
          )}
          {getLabelTagInput(
            "Mins Walked",
            getLabelTag(minsWalkedOptions, formData?.six_min_walk?.mins_walked)
          )}
          {getLabelTagInput(
            "Reasons for Stopping",
            getLabelTag(
              reasonOptions,
              formData?.six_min_walk?.reason_for_immediate_stopping
            )
          )}
          {getLabelTagInput(
            "Others details",
            formData?.six_min_walk?.reason_for_immediate_stopping_others
          )}
          {getLabelTagInput("Comments", formData?.six_min_walk?.comments)}
        </>
      );
    }

    if (checkEmpty(formData?.peak_flow_meter_test)) {
      pushSummaryItem(
        "10",
        "Peak Flow Meter Test",
        <>
          {" "}
          {getLabelTag(
            peakFlowGenderOptions,
            formData?.peak_flow_meter_test?.gender
          )}
          {getLabelTagInput("Age", formData?.peak_flow_meter_test?.age)}
          {getLabelTagInput(
            "Height",
            formData?.peak_flow_meter_test?.height,
            "cm"
          )}
          {getLabelTagInput(
            "Predicted PEFR",
            formData?.peak_flow_meter_test?.predicted_PEFR ??
              predictPEFR(
                formData?.peak_flow_meter_test?.gender,
                formData?.peak_flow_meter_test?.age,
                formData?.peak_flow_meter_test?.height
              )
          )}
          {getLabelTagInput(
            "Tested PEFR",
            formData?.peak_flow_meter_test?.test_PEFR
          )}
          {getLabelTagInput(
            "Comments",
            formData?.peak_flow_meter_test?.comments
          )}
        </>
      );
    }

    if (checkEmpty(formData?.functional_diagnosis)) {
      const functionalDiagnosisValues =
        formData?.functional_diagnosis?.diagnosis;
      const showFunctionalDiagnosisOthers =
        Array.isArray(functionalDiagnosisValues) &&
        functionalDiagnosisValues.includes("others");
      pushSummaryItem(
        "11",
        "Functional Diagnosis",
        <>
          {getLabelTagsArray(cardioDiagnosisOptions, functionalDiagnosisValues)}
          {showFunctionalDiagnosisOthers &&
            getLabelTagsWithDynamicInputs(
              formData?.functional_diagnosis?.diagnosis_others
            )}
          {getLabelTagInput(
            "Comments",
            formData?.functional_diagnosis?.diagnosis_comments
          )}
        </>
      );
    }

    if (checkEmpty(formData?.therapy)) {
      pushSummaryItem(
        "12",
        "Therapy",
        <>
          {getTherapyLabelTags(cardioTherapyOptions, formData?.therapy)}
          {getLabelTagsWithDynamicInputs(formData?.therapy?.others)}
        </>
      );
    }

    const exerciseList = Array.isArray(formData?.exercise)
      ? formData.exercise
      : Object.values(formData?.exercise || {});

    if (exerciseList.length > 0) {
      pushSummaryItem("13", "Exercise", getExerciseSummary(exerciseList));
    }

    if (
      formData?.review_notes &&
      Object.keys(formData.review_notes).length > 0
    ) {
      pushSummaryItem(
        "14",
        "Review Notes",
        <>
          {formData.review_notes.progress_notes &&
            getLabelTagInput(
              "Progress Notes",
              formData.review_notes.progress_notes
            )}

          {formData.review_notes.review_notes &&
            getLabelTagInput(
              "Review Notes",
              formData.review_notes.review_notes
            )}
        </>
      );
    }

    return cardioSummaryItems;
  };
  const cardioSummaryItems = constructCardioSummaryItems();
  return <SummaryWrapper items={cardioSummaryItems} />;
};

export default CardioSummary;
